import React from 'react';
import { Img, ContentsContainer, ItemInfoContainer, ItemInfo, FormItem } from 'components';

export interface Props {
    businessRegistrationNumber: string;
    businessRegistrationImage: string;
    businessRegistrationOwner: string;
    familyRelationImage: string;
    taxClassification: string;
}
/** 사업자 등록증 **/
function BusinessRegistration({ businessRegistrationNumber, businessRegistrationImage, businessRegistrationOwner, familyRelationImage, taxClassification }: Props): React.ReactElement {
    return (
        <ContentsContainer title={'사업자 등록증'}>
            <ItemInfoContainer>
                <ItemInfo title={'사업자 명의'} contents={businessRegistrationOwner} />
                <ItemInfo title={'사업자 번호'} contents={businessRegistrationNumber} />
                <ItemInfo title={'사업자 정보'} contents={taxClassification} />
            </ItemInfoContainer>
            <FormItem label={'사업자등록증사진'}>
                <Img alt={'사업자등록증'} src={businessRegistrationImage} />
            </FormItem>
            {businessRegistrationOwner === '가족' ? (
                <FormItem label={'가족관계증명서'}>
                    <Img alt={'가족관계증명서'} src={familyRelationImage} />
                </FormItem>
            ) : null}
        </ContentsContainer>
    );
}

export default BusinessRegistration;
